import { RootState } from '../../../common/store/store';

export const selectRejectedList = (state: RootState): number[] => state.collectionTool.suggestionList.rejectedList;

export const selectSuggestionList = (state: RootState) => state.collectionTool.suggestionList;
